<div class="row-compact baseline">
	<div class="lineout wide pointer">
		<div data-ref="name"></div>
	</div>
	<button class="lineout float-end" data-ref="delete">✖</button>
	<button class="lineout" data-ref="open">open</button>
</div>
